//External imports
import { useEffect, useRef } from 'react'
import { TouchableOpacity } from 'react-native'
import { GoogleLogin,GoogleOAuthProvider,useGoogleLogin } from '@react-oauth/google';
import { fp, hp, spH, spV, wp } from "utils/normalizeV2";
import { StyleSheet } from 'react-native';
import ImageView from '../../../src/image';
import { Svg as Svgs } from 'assets/svg'
import VText from './../VText'



const GoogleSignButton = ({ onSuccess }) => {
    const signIn = useGoogleLogin({
        scope: 'profile email',
        onSuccess: (response) => {
            onGoogleLoginSuccess(response)
        },
        onError: onGoogleLoginError,
    });

    const onGoogleLoginSuccess = (response) => {   
        onSuccess(response);

    };

    const onGoogleLoginError = (error) => {
        console.log('error', error);
    };

  
    return (

            <TouchableOpacity onPress={signIn} style={styles.appleButton}>
                <VText style={styles.buttonText}>Continue with Google</VText>
                <ImageView source={Svgs.gmailIcon} style={{ width: 28, height: 28, marginLeft: 10 }} />
            </TouchableOpacity>
    );
  
};

const styles = StyleSheet.create({
    appleButton: {
      width: wp(375),
      height: hp(50)  ,
      padding: 10,
      border: '1px solid #E6E8E7',
      borderRadius: fp(4),
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      cursor: 'pointer',
      flexDirection: 'row'
    },
    buttonText: {
      color: '#212427',
      fontWeight: '600',
      fontSize:fp(14),
      // marginRight:hp(4)
    }
  });


const  GoogleAuth = ({onSuccess}) => {
    return <GoogleOAuthProvider clientId={process.env.EXPO_PUBLIC_GOOGLE_CLIENT_ID}>
            <GoogleSignButton onSuccess={onSuccess} />
</GoogleOAuthProvider>

}


export default GoogleAuth



    // return (

    //         <TouchableOpacity onPress={signIn} style={styles.appleButton}>
    //             <VText style={styles.buttonText}>Continue with Google</VText>
    //             <ImageView source={Svgs.gmailIcon} style={{ width: 25, height: 25, marginLeft: 10 }} />
    //         </TouchableOpacity>
    // );